/* unplugin-vue-components disabled */import script from "./addModal.vue?vue&type=script&setup=true&lang=js"
export * from "./addModal.vue?vue&type=script&setup=true&lang=js"

import "./addModal.vue?vue&type=style&index=0&id=667f72d8&lang=less&scoped=true"
import "./addModal.vue?vue&type=style&index=1&id=667f72d8&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667f72d8"]])

export default __exports__